'use client';
import {MAIN_LIST_CNT, MY_PLUS_VOD_CONTEXT_MENU} from '@/constants/main';
import {useState, useEffect} from 'react';
import useMainStore from '@/stores/main';
import {SectionHeader} from '@/components/main/common';
import VodBroadcastItem from '../VodBroadcastItem';
import {BROADCAST_TYPES} from '@/constants';
import {getDomParser} from '@/utils/main/my-plus/section';

export const VodGroup = ({response, isVod = true, order}) => {
  const [visibleListCount, setVisibleListCount] = useState(0);
  const [isClickMore, setIsClickMore] = useState(false);
  const {resizeMainLiveCount} = useMainStore();

  const headerText = '관심 VOD';

  const handleShowMore = () => {
    if (visibleListCount < MAIN_LIST_CNT) {
      const visibleCount = MAIN_LIST_CNT - visibleListCount;
      setVisibleListCount((prev) => prev + visibleCount);
    } else {
      const visibleCount = response.vodCnt - visibleListCount;
      setVisibleListCount((prev) => prev + visibleCount);
    }
    setIsClickMore(true);
  };

  useEffect(() => {
    if (resizeMainLiveCount > 0 && !isClickMore) {
      setVisibleListCount(resizeMainLiveCount * 2);
    }
  }, [resizeMainLiveCount]);

  return (
    <>
      <SectionHeader title={headerText} />
      {response && response.vodList?.length > 0 ? (
        <>
          <div className='cBox-list'>
            <ul>
              {response.vodList?.map(
                (broadcast, idx) =>
                  idx < visibleListCount && (
                    <li data-type='cBox' key={broadcast.titleNo}>
                      <VodBroadcastItem
                        broadcastType={BROADCAST_TYPES.VOD}
                        location='myplus'
                        broadcastId={broadcast.titleNo}
                        authNumber={broadcast.authNo}
                        vodType={broadcast.fileType}
                        duration={broadcast.vodDuration}
                        categoryName={broadcast.categoryName}
                        categoryTags={broadcast.categoryTags}
                        categoryNo={broadcast.category}
                        vodCategoryNo={broadcast.vodCategory}
                        autoHashTags={broadcast.autoHashtags}
                        hashTags={broadcast.hashTags}
                        allowsAdult={
                          Number(broadcast.grade) === 19 &&
                          Number(broadcast.category) === 30000
                        }
                        accessibleAge={Number(broadcast.grade)}
                        hasBadge={true}
                        thumbnailUrl={broadcast.thumbnail}
                        title={broadcast.title}
                        isPpv={broadcast.ppv}
                        userId={broadcast.userId}
                        userNickname={broadcast.userNick}
                        originalUserId={broadcast.originalUserId}
                        originalUserNickname={broadcast.originalUserNick}
                        viewCount={broadcast.viewCnt}
                        createdDate={broadcast.regDate}
                        previewThumbnailUrl={broadcast.webpPath}
                        listDataType={broadcast.listDataType}
                        score={broadcast.score}
                        contextMenu={{
                          menuList: MY_PLUS_VOD_CONTEXT_MENU,
                        }}
                        log={{
                          data: {
                            path3: 'vod',
                            sectionIdx: order,
                            sectionTitle: getDomParser(headerText),
                          },
                        }}
                      />
                    </li>
                  ),
              )}
            </ul>
          </div>
          {response.vodCnt > visibleListCount ? (
            <div className='show_more'>
              <button type='button' onClick={handleShowMore}>
                더보기
              </button>
            </div>
          ) : (
            <i className={'divider'} />
          )}
        </>
      ) : (
        <div className='nt_area'>
          <p>VOD가 없습니다.</p>
        </div>
      )}
    </>
  );
};
